import { render } from "./RankingChips.vue?vue&type=template&id=5415b268&scoped=true"
import script from "./RankingChips.vue?vue&type=script&lang=js"
export * from "./RankingChips.vue?vue&type=script&lang=js"

import "./RankingChips.vue?vue&type=style&index=0&id=5415b268&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5415b268"]])

export default __exports__